/**
 * Azul Hosted Payment Page redirect.
 * Receives actionUrl and formFields, builds a hidden HTML form, and auto-submits POST.
 */

import { useEffect, useRef } from "react";

export interface AzulRedirectProps {
  actionUrl: string;
  formFields: Record<string, string>;
  /** Optional message while redirecting */
  message?: string;
}

export function AzulRedirect({ actionUrl, formFields, message = "Redirigiendo a la pasarela de pago…" }: AzulRedirectProps) {
  const formRef = useRef<HTMLFormElement>(null);

  useEffect(() => {
    if (!formRef.current || !actionUrl) return;
    formRef.current.submit();
  }, [actionUrl]);

  return (
    <div className="min-h-[200px] flex flex-col items-center justify-center p-6">
      <p className="text-[#1d1d1f] font-medium mb-6">{message}</p>
      <form
        ref={formRef}
        method="POST"
        action={actionUrl}
        className="hidden"
        aria-hidden="true"
      >
        {Object.entries(formFields).map(([name, value]) => (
          <input
            key={name}
            type="hidden"
            name={name}
            value={value}
            readOnly
          />
        ))}
        <button type="submit" tabIndex={-1} aria-hidden="true">
          Enviar
        </button>
      </form>
      <div className="animate-spin rounded-full h-8 w-8 border-2 border-[#d2d2d7] border-t-[#161b3d]" aria-hidden />
    </div>
  );
}
